import React from "react";
import { useSelector } from "react-redux";

export const DatosCobros = () => {
  const { fechaFactura, fechaFacturaPagada, noSeCobra, motivoNoSeCobra, montoCobrado } =
    useSelector((state) => state.detalleReducer.asistencia);

  if (!noSeCobra && !fechaFactura && !fechaFacturaPagada) return null;

  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "2px 16px" }}>
      {noSeCobra && (
        <div><span className="inputLabel">Cobro: </span>{motivoNoSeCobra || "No se cobra"}</div>
      )}
      {fechaFactura && (
        <div><span className="inputLabel">Factura: </span>{fechaFactura.slice(0, 10)}</div>
      )}
      {fechaFacturaPagada && (
        <div><span className="inputLabel">Pagada: </span>{fechaFacturaPagada.slice(0, 10)}</div>
      )}
      {montoCobrado && (
        <div><span className="inputLabel">Monto: </span>{montoCobrado}</div>
      )}
    </div>
  );
};